import "src/decidim/survey_results/application.js";

// Images
require.context("../images", true)

import "entrypoints/decidim_survey_results.scss"
